// src/components/Header.jsx
import React, { useState } from 'react';
import Navigation from './Navigation';

import { assets } from '../assets/asset_importer';
const logo = assets.icons.site.integralis_logo;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((open) => !open);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo-section">
          <img src={logo} alt="Integralis Logo" className="logo" />
          <h1 className="site-title">Integralis</h1>
        </div>

        <button
          className={`burger ${isMenuOpen ? 'burger--open' : ''}`}
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={isMenuOpen}
          onClick={toggleMenu}
        >
          <span />
          <span />
          <span />
        </button>

        <Navigation isOpen={isMenuOpen} onLinkClick={closeMenu} />
      </div>
    </header>
  );
};

export default Header;
